.root {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  font-weight: 600;
  padding: 5px 10px;
  border-radius: var(--radius-pill);
  border: 1px solid transparent;
  white-space: nowrap;
}

.icon {
  font-size: 14px;
}

.ok {
  color: var(--color-success);
  background: var(--color-success-soft);
  border-color: rgba(34, 122, 76, 0.18);
}

.busy {
  color: var(--color-text-secondary);
  background: var(--color-surface-sunken);
  border-color: var(--color-border);
}

.error {
  color: var(--color-danger);
  background: var(--color-danger-soft);
  border-color: rgba(164, 41, 31, 0.18);
}
